import React from 'react'
import moment from 'moment'
import { useStyles } from './style'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { formatDate, priceFormatLocal } from 'utils/helper'
import { Divider } from '@mui/material'

const DetailOrder = ({ data, onBack }) => {
  const styles = useStyles()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <>
      <button className={styles.backButton} onClick={onBack}>
        Back
      </button>
      <div className={styles.boxInfo} style={{ flexDirection: isMobile ? 'column' : 'row' }}>
        <table style={{ width: isMobile ? '100%' : '65%' }}>
          <tr>
            <td>DO Number</td>
            <td>:</td>
            <td>{data.order_delivery_number}</td>
          </tr>
          <tr>
            <td>Order Date</td>
            <td>:</td>
            <td>{moment(data.created_at).format('DD-MM-YYYY hh:mm')}</td>
          </tr>
          <tr>
            <td>Requestor</td>
            <td>:</td>
            <td>{data.order_delivery_item[0].order_data.customer.name}</td>
          </tr>
          <tr>
            <td>HOD</td>
            <td>:</td>
            <td>{data.order_delivery_item[0].order_data.approval_customer.name}</td>
          </tr>
          <tr>
            <td>PO Status</td>
            <td>:</td>
            <td>{data.status}</td>
          </tr>
        </table>
        <Divider sx={{ width: isMobile ? '100%' : '0', my: isMobile ? 1.5 : 0 }} />
        <div style={{ width: isMobile ? '100%' : '35%' }}>
          <p>{data.order_delivery_item[0].order_data.customer_address.name}</p>
          <p>{data.order_delivery_item[0].order_data.customer_address.phone}</p>
          <p>{data.order_delivery_item[0].order_data.customer_address.address}</p>
        </div>
      </div>
      <div className={styles.boxProduct}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size='small' aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell style={{ minWidth: 340 }}>Product Name</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Unit Price</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>PO Number</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.order_delivery_item.length > 0 &&
                data.order_delivery_item.map(item => (
                  <TableRow
                    key={item.order_item.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell>
                      <div style={{ display: 'flex', gap: 12 }}>
                        <img
                          className={styles.itemImg}
                          src={
                            item.order_item.product.media
                              ? process.env.REACT_APP_FILE_BASE_URL +
                                '/' +
                                item.order_item.product.media[0]
                              : '/assets/images/dummy.png'
                          }
                        />
                        <div>
                          <p>{item.order_item.product.name}</p>
                          <table className={styles.itemInfoTable}>
                            <tbody>
                              <tr>
                                <td>Material ID</td>
                                <td style={{ padding: '0 6px' }}>:</td>
                                <td>{item.order_item.product.sku}</td>
                              </tr>
                              <tr>
                                <td>G/L Account</td>
                                <td style={{ padding: '0 6px' }}>:</td>
                                <td>
                                  {item.general_ledger_accounts
                                    .map(gla => gla.general_ledger_account.name)
                                    .join(', ')}
                                </td>
                              </tr>
                              <tr>
                                <td>PO Reason</td>
                                <td style={{ padding: '0 6px' }}>:</td>
                                <td>{item.order_item.po_reason}</td>
                              </tr>
                              {item.order_item.note && (
                                <tr>
                                  <td>Notes</td>
                                  <td style={{ padding: '0 6px' }}>:</td>
                                  <td>{item.order_item.note}</td>
                                </tr>
                              )}
                              {item.order_item.expect_date && (
                                <tr>
                                  <td>Expect Delivery Date</td>
                                  <td style={{ padding: '0 6px' }}>:</td>
                                  <td>{formatDate(item.order_item.expect_date)}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>{item.order_delivery_item.quantity}</TableCell>
                    <TableCell>{priceFormatLocal(item.order_item.price)}</TableCell>
                    <TableCell>{priceFormatLocal(item.order_item.total)}</TableCell>
                    <TableCell>{item.order_data.order_number}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: 250 }}>
              <p>Total ({data.order_delivery_item[0].order_delivery_item.quantity} items)</p>
              <p>{priceFormatLocal(data.order_delivery_item[0].order_data.total)}</p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: 250 }}>
              <p>Grand Total</p>
              <p>{priceFormatLocal(data.order_delivery_item[0].order_data.grand_total)}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DetailOrder
